import Field, { AggregationType, FieldType } from "@dto/fields";
import { z } from "zod";
import { UseFormReturn } from "react-hook-form";
import { LinkTypeItemsForm } from "./LinkTypeItemsForm";
import { ChoiceTypeItemsForm } from "./ChoiceTypeItemsForm";
import { PeriodTypeItemsForm } from "./PeriodTypeItemsForm";
import { ButtonTypeItemsForm } from "./ButtonTypeItemsForm";

const formSchema = z.object({
    fieldName: z.string(),
    fieldType: z.nativeEnum(FieldType).optional(),
    fieldFormat: z.map(z.string(), z.any()).optional(),
    fieldTypeItems: z.map(z.string(), z.any()).optional(),
})

export interface FieldTypeItemsFormProps {
    field: Field,
    form: UseFormReturn<z.infer<typeof formSchema>>,
    onTypeItemsChange: (typeItems: Map<string, any>) => void,
    setError: (error: string) => void,
    updateAggregation: (aggregation: AggregationType) => void
}

export const FIELD_TYPES_WITH_TYPE_ITEMS = [FieldType.Link, FieldType.Choice, FieldType.MultiChoice, FieldType.Period, FieldType.Button];

export function FieldTypeItemsForm({ field, form, onTypeItemsChange, setError, updateAggregation }: FieldTypeItemsFormProps) {
    switch (field.type) {
        case FieldType.Link:
            return <LinkTypeItemsForm field={field} form={form} onTypeItemsChange={onTypeItemsChange} setError={setError} updateAggregation={updateAggregation} />
        case FieldType.Choice:
            return <ChoiceTypeItemsForm field={field} form={form} onTypeItemsChange={onTypeItemsChange} setError={setError} updateAggregation={updateAggregation} />
        case FieldType.MultiChoice:
            return <ChoiceTypeItemsForm field={field} form={form} onTypeItemsChange={onTypeItemsChange} setError={setError} updateAggregation={updateAggregation} />
        case FieldType.Period:
            return <PeriodTypeItemsForm field={field} form={form} onTypeItemsChange={onTypeItemsChange} setError={setError} updateAggregation={updateAggregation} />
        case FieldType.Button:
            return <ButtonTypeItemsForm field={field} form={form} onTypeItemsChange={onTypeItemsChange} setError={setError} updateAggregation={updateAggregation} />
        default:
            return <div></div>
    }
}